import RestaurantBlock from "@components/Blocks/RestaurantBlock/RestaurantBlock";
import RelatedArticle from "@components/Layouts/RelatedArticle/RelatedArticle";
import { ArticleReactionOptions } from "@elements/Reactions/ArticleReactionOptions";
import { CAS_CDP_REGWALL_ID } from "@helper/getEnvVariables";
import generateGoogleMapsLink from "@helper/googleMapsLink";
import { isArrayWithElements } from "@helper/utils";
import ArticleElementWrapper from "@pages/Article/Components/ArticleElementWrapper";

import CASBlock from "../../Blocks/CASBlock/CASBlock";
import AttachmentCard from "../AttachmentCard/AttachmentCard";
import { RenderTags } from "../Typography/Tags";
import { ArticleParagraphProps } from "./ArticleParagraph";

type PostContentSectionProps = Pick<
  ArticleParagraphProps,
  | "relatedArticles"
  | "attachments"
  | "isInfiniteScrollArticle"
  | "tags"
  | "pageNumber"
  | "articleId"
  | "showReactions"
  | "reactions"
  | "userReactions"
  | "handleReactionClick"
  | "freeArticle"
> & {
  isCasScriptReady: boolean;
};

export function PostContentSection(props: PostContentSectionProps) {
  const {
    freeArticle,
    attachments,
    isInfiniteScrollArticle,
    relatedArticles,
    tags,
    pageNumber,
    isCasScriptReady,
    articleId,
    showReactions,
    reactions,
    userReactions,
    handleReactionClick,
  } = props;
  const casBlockProps = {
    key: `cas-${CAS_CDP_REGWALL_ID}`,
    casId: CAS_CDP_REGWALL_ID,
    ...(isInfiniteScrollArticle && { index: pageNumber }),
  };

  const googleMapLink = generateGoogleMapsLink(
    freeArticle?.location?.address || "",
  );

  return (
    <>
      <ArticleElementWrapper>
        {isArrayWithElements(attachments) && (
          <div className="my-6 lg:my-8 flex flex-col gap-3">
            {attachments.map((attachment, idx) => (
              <AttachmentCard key={idx} attachment={attachment} />
            ))}
          </div>
        )}

        {freeArticle?.location && (
          <RestaurantBlock
            location={freeArticle.location}
            googleMapLink={googleMapLink}
          />
        )}

        {showReactions && reactions.length > 0 && (
          <div className="my-5 lg:my-8">
            <ArticleReactionOptions
              reactions={reactions}
              handleReactionClick={handleReactionClick}
              reactionsUser={userReactions}
              articleId={articleId}
              variant="bottom"
            />
          </div>
        )}

        {isArrayWithElements(relatedArticles) && (
          <div className="my-6 lg:my-8">
            <RelatedArticle relatedArticles={relatedArticles} />
          </div>
        )}

        <RenderTags tagsWrapper="my-6 lg:my-8 gap-[10px]" tags={tags} />
      </ArticleElementWrapper>

      {isCasScriptReady && (
        <ArticleElementWrapper>
          <CASBlock className="mt-md" {...casBlockProps} />
        </ArticleElementWrapper>
      )}
    </>
  );
}
